"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountProgram = void 0;
var getCountProgram = function (countProgram) {
    if (countProgram === 1) {
        return '1 программа';
    }
    else if (countProgram >= 2 && countProgram <= 4) {
        return "".concat(countProgram, " \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B");
    }
    return "".concat(countProgram, " \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C");
};
exports.getCountProgram = getCountProgram;
